module.exports = __webpack_public_path__ + "img/16581245_L.7b60cd80.png";